import { render, staticRenderFns } from "./QuestionTextArea.vue?vue&type=template&id=3a7d2c4e&scoped=true"
import script from "./QuestionTextArea.vue?vue&type=script&lang=js"
export * from "./QuestionTextArea.vue?vue&type=script&lang=js"
import style0 from "./QuestionTextArea.vue?vue&type=style&index=0&id=3a7d2c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7d2c4e",
  null
  
)

export default component.exports